"use client";

import { Quotes } from "@phosphor-icons/react/dist/ssr";
import { useMemo } from "react";

import { FadeInIntersection } from "@/common/components";
import {
  Carousel,
  CarouselContent,
  CarouselDotButton,
  CarouselDotNavigation,
  CarouselItem,
} from "@/common/components/carousel";
import { Section } from "@/common/components-2/section";
import { SectionHeading } from "@/common/components-2/section-heading";
import { useTranslations } from "@/services/i18n";

export function TestimonialsSection() {
  const t = useTranslations("pages.consultations.testimonials");

  const items = useMemo(() => [t("items.1"), t("items.2"), t("items.3"), t("items.4")], [t]);

  return (
    <FadeInIntersection rootMargin="0px 0px -300px 0px" delay={100} asChild animation="fadeUp">
      <Section classes={{ section: "bg-white-linen-50 py-8 md:py-20 lg:py-24" }}>
        <SectionHeading
          heading={t.rich("heading")}
          description={t("description")}
          classes={{ description: "text-center" }}
        />
        <div className="md:mx-auto">
          <Carousel className="mt-10 md:mt-14">
            <CarouselContent>
              {items.map((item, index) => (
                <CarouselItem
                  key={item}
                  className="max-w-[312px] animate-fill-forwards pl-8 opacity-0 group-[.animate-intersected-in]/intersected:animate-fade-right md:max-w-[280px]"
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <div className="flex h-full flex-col justify-center gap-6 rounded-2xl bg-card p-6 text-left">
                    <Quotes className="size-12" />
                    <p>{item}</p>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselDotNavigation
              items={(selectedIndex) =>
                items.map((item, index) => (
                  <CarouselDotButton
                    className={index === selectedIndex ? "bg-dodger-blue-700" : "bg-muted-foreground"}
                    key={item}
                    index={index}
                    active={index === selectedIndex}
                    aria-label={`${index + 1}`}
                  />
                ))
              }
              className="mt-8 md:hidden"
            />
          </Carousel>
        </div>
        <p className="mt-10 text-center text-base md:mt-14">{t("info")}</p>
      </Section>
    </FadeInIntersection>
  );
}
